import { render, staticRenderFns } from "./material-sum-filter.vue?vue&type=template&id=3feedc20"
import script from "./material-sum-filter.vue?vue&type=script&lang=js"
export * from "./material-sum-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports